/**
 * Class which holds methods for string checks and manipulation.
 */
export class StringsUtils {
  /**
   * Checks if string is not empty.
   * @param value String to be checked
   */
  static isNotEmpty(value: string): boolean {
    return value && value.length > 0;
  }

  /**
   * Checks if string si empty.
   * @param value to be checked
   */
  static isEmpty(value: string): boolean {
    return !this.isNotEmpty(value);
  }
}
